import React, { Component } from 'react';
import { MobileEditorLeftBar, DesktopEditorLeftBar } from 'crazyEditor/components';
const classes = require('shared/styles/common.scss');

export default class EditorLeftBar extends Component {
  render() {
    const { isMobileView, isDesktopView } = this.props;
    return (
      <div className={classes.noSelect}>
        {isMobileView && <MobileEditorLeftBar />}
        {isDesktopView && <DesktopEditorLeftBar />}
      </div>
    );
  }
}
